import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { Toolbar as RAC_Toolbar } from 'react-aria-components';
import styles from './Toolbar.module.css';
import type { ToolbarProps } from './Toolbar.types';
const Toolbar = t0 => {
  const $ = _c(11);
  const {
    ariaLabel,
    children,
    orientation: t1,
    space: t2,
    width: t3
  } = t0;
  const orientation = t1 === undefined ? "horizontal" : t1;
  const space = t2 === undefined ? "--by-space-100" : t2;
  const width = t3 === undefined ? "auto" : t3;
  const t4 = orientation === "horizontal";
  const t5 = orientation === "vertical";
  const t6 = width === "full";
  let t7;
  if ($[0] !== t4 || $[1] !== t5 || $[2] !== t6) {
    t7 = clsx(styles.toolbar, {
      [styles.horizontal]: t4,
      [styles.vertical]: t5,
      [styles.fullWidth]: t6
    });
    $[0] = t4;
    $[1] = t5;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const toolbarStyles = t7;
  const t8 = `var(${space})`;
  let t9;
  if ($[4] !== t8) {
    t9 = {
      "--toolbar-space": t8
    };
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const spacingToken = t9 as React.CSSProperties;
  let t10;
  if ($[6] !== ariaLabel || $[7] !== children || $[8] !== spacingToken || $[9] !== toolbarStyles) {
    t10 = <RAC_Toolbar aria-label={ariaLabel} data-test-id="Toolbar" className={toolbarStyles} style={spacingToken}>{children}</RAC_Toolbar>;
    $[6] = ariaLabel;
    $[7] = children;
    $[8] = spacingToken;
    $[9] = toolbarStyles;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
export { Toolbar };